/* eslint-disable no-unused-expressions */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable prefer-template */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable semi */
/* eslint-disable arrow-parens */
const ArgumentType = require('../../extension-support/argument-type');
const BlockType = require('../../extension-support/block-type');
const formatMessage = require('format-message');//翻译用
const blockIconURI = require('./icon.png');
// const menuIconURI = blockIconURI;

// const valueDelay = valueDelayPromise.bind(aixiongBlocks)

class dataVisualizationBlocks {
    constructor(runtime) {
        /**
         * The runtime instantiating this block package.
         * @type {Runtime}
         */
        this.runtime = runtime;
        // console.log('this.runtime --> ', runtime)

        if (this.runtime.ioDevices) {
            this.ioDevices = this.runtime.ioDevices
            this.Aixiong = this.ioDevices.Aixiong
            this.runMode = this.Aixiong.runMode
            // this.socket = this.Aixiong.socket
            this.adaptor = this.Aixiong.adaptor
            this.running = false
            //console.log('###this.ioDevices --> ', this.ioDevices)
        }
        this.getAccessToken = () => {
            let _search = location.search;
            location._query = {};
            location._query['lang'] = 'en';
            let queryArray = [];
            if (_search) {
                _search = _search.replace('?', '');
                queryArray = _search.split('&');
                for (var i = 0; i < queryArray.length; i++) {
                    location._query[queryArray[i].split('=')[0]] = queryArray[i].split('=')[1];
                }
            }
            let accessToken = location._query['accessToken'];
            let domain = location._query['domain'] || 'https://coursedev.e-ai-edu.com';
            return {
                accessToken,
                domain
            }
        };
        this.domain = this.getAccessToken().domain;
        this.accessToken = this.getAccessToken().accessToken;

        this.nowyear = new Date().getFullYear();
        this.nowmonth = new Date().getMonth() + 1;
        this.nowday = new Date().getDate() - 1;
        this.nowtime = new Date().getHours();

    }

    /**
     * The key to load & store a target's test-related state.
     * @type {string}
     */
    static get STATE_KEY() {
        return 'Scratch.dataVisualization';
    }

    /**
     * @returns {object} metadata for this extension and its blocks.
     */
    getInfo() {
        return {
            // 详细介绍：https://github.com/LLK/scratch-vm/blob/develop/docs/extensions.md
            // Required: the machine-readable name of this extension.
            // Will be used as the extension's namespace.
            id: 'dataVisualization',
            name: '数据可视化',
            // Optional: URI for an icon to be displayed in the blocks category menu.
            menuIconURI: blockIconURI, //menuIconURI,
            // Optional: URI for a block icon, to display at the edge of each block for this
            blockIconURI: blockIconURI,
            color1: '#29BEAF',
            // Optional: Link to documentation content for this extension.
            // If not present, offer no link.
            // docsURI: 'https://....',
            // 插件右上角的硬件连接状态显示按钮
            showStatusButton: false,
            blocks: [
                {
                    opcode: 'openChartWindow',
                    blockType: BlockType.COMMAND,
                    text: '打开图表化窗口'
                },
                {
                    opcode: 'setChartTitle',
                    blockType: BlockType.COMMAND,
                    text: '设置图表标题 [title]',
                    arguments: {
                        title: {
                            type: ArgumentType.STRING,
                            defaultValue: '标题'
                        }
                    }
                },
                {
                    opcode: 'setChartType',
                    text: '设置图表类型为 [chartType]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        chartType: {
                            type: ArgumentType.STRING,
                            menu: 'chartType',
                            defaultValue: 'table'
                        }
                    }
                },
                {
                    opcode: 'setRenderSpeed',
                    text: '设置渲染速度 [renderSpeed]',
                    blockType: BlockType.COMMAND,
                    arguments: {
                        renderSpeed: {
                            type: ArgumentType.STRING,
                            menu: 'renderSpeed',
                            defaultValue: 'no_delay'
                        }
                    }
                },
                {
                    opcode: 'setAxisTitle',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: '设置轴标题：x轴 [axisX] y轴 [axisY]',
                    arguments: {
                        axisX: {
                            type: ArgumentType.STRING,
                            defaultValue: 'date',
                        },
                        axisY: {
                            type: ArgumentType.STRING,
                            defaultValue: 'temperature/℃',
                        },
                    },
                },
                {
                    opcode: 'setRightYTitle',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: '设置右y轴标题：[rightYTitle] ',
                    arguments: {
                        rightYTitle: {
                            type: ArgumentType.STRING,
                            defaultValue: 'humidity/%',
                        },
                    },
                },
                {
                    opcode: 'setDataGroup',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: '设置数据组：[rightY] 到 [axis]',
                    arguments: {
                        rightY: {
                            type: ArgumentType.STRING,
                            defaultValue: 'indoor',
                        },
                        axis: {
                            type: ArgumentType.STRING,
                            menu: 'axisType',
                            defaultValue: 'left_y'
                        }
                    },
                },
                {
                    opcode: 'inputVariables',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: '输入：[variablesData] 的数据：x轴 [variablesX] y轴 [variablesY]',
                    arguments: {
                        variablesData: {
                            type: ArgumentType.STRING,
                            defaultValue: 'indoor',
                        },
                        variablesX: {
                            type: ArgumentType.STRING,
                            defaultValue: 'monday'
                        },
                        variablesY: {
                            type: ArgumentType.STRING,
                            defaultValue: '15'
                        }
                    },
                },
                {
                    opcode: 'inputVariablesTerm',
                    blockType: BlockType.COMMAND, // BOOLEAN, COMMAND
                    text: '输入：[variablesData] 的数据：项 [variablesX] 值 [variablesY]',
                    arguments: {
                        variablesData: {
                            type: ArgumentType.STRING,
                            defaultValue: 'indoor',
                        },
                        variablesX: {
                            type: ArgumentType.STRING,
                            defaultValue: 'monday'
                        },
                        variablesY: {
                            type: ArgumentType.STRING,
                            defaultValue: '15'
                        }
                    },
                },
                {
                    opcode: 'clearChart',
                    blockType: BlockType.COMMAND,
                    text: '清空图表数据'
                },
                {
                    opcode: 'closeChartWindow',
                    blockType: BlockType.COMMAND,
                    text: '关闭图表窗口'
                },
            ],
            menus: {
                chartType: [
                    { text: '表格', value: 'table' },
                    { text: '折线图', value: 'line' },
                    { text: '柱状图', value: 'histogram' },
                    { text: '双轴图', value: 'biaxial' },
                    { text: '饼图', value: 'pie' },
                ],
                renderSpeed: [
                    { text: '无延迟', value: 'no_delay' },
                    { text: '快', value: 'fast' },
                    { text: '慢', value: 'slow' },
                ],
                axisType: [
                    { text: '左y轴', value: 'left_y' },
                    { text: '右y轴', value: 'right_y' },
                ]
            }
        };
    }

    /**
     * TODO 这个是摘取过来的，作用还没有彻底搞明白。
     * Retrieve the block primitives implemented by this package.
     * @return {object.<string, Function>} Mapping of opcode to Function.
     */
    openChartWindow(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'openChartWindow', args });
    };
    setChartTitle(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setChartTitle', args });
    };
    setChartType(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setChartType', args });
    };
    setRenderSpeed(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setRenderSpeed', args });
    };
    setAxisTitle(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setAxisTitle', args });
    };
    setRightYTitle(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setRightYTitle', args });
    };
    setDataGroup(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'setDataGroup', args });
    };
    inputVariables(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'inputVariables', args });
    };
    inputVariablesTerm(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'inputVariables', args });
    };
    clearChart(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'clearChart', args });
    };
    closeChartWindow(args) {
        this.runtime.emit("DATA_VISUALIZATION", { type: 'closeChartWindow', args });
    };
}

module.exports = dataVisualizationBlocks;
